import { getInitialState, getPath } from "../../utils";

const initialState = {
  featureToggleList: [],
  prevPage: -1,
  nextPage: -1,
  activeFeatureToggle: {},
  activeFiltersToggle: {},
  currentPageFeatureToggle: 1,
  dsmEnabledFeatures: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_FEATURE_TOGGLE_LIST":
      return setFeatureToggleList(state, action);
    case "SET_ACTIVE_FEATURE_TOGGLE":
      return setActiveFeatureToggle(state, action);
    case "SET_ACTIVE_FILTERS_TOGGLE":
      return setActiveFiltersToggle(state, action);
    case "SET_CURRENT_PAGE_FEATURE_TOGGLE":
      return setCurrentPageFeatureToggle(state, action);
    case "RESET_STATE_FEATURE_TOGGLE":
      return resetStateFeatureToggle(state, action);
    case "SET_DSM_ENABLED_FEATURES":
      return setDSMEnabledFeatures(state, action);
    default:
      return state;
  }
}

const setCurrentPageFeatureToggle = (state, action) => {
  return {
    ...state,
    currentPageFeatureToggle: action.payload,
  };
};

const setFeatureToggleList = (state, action) => {
  return {
    ...state,
    featureToggleList: getPath(action.payload, "featureToggles", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetStateFeatureToggle = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveFeatureToggle = (state, action) => {
  return {
    ...state,
    activeFeatureToggle: action.payload,
  };
};

const setActiveFiltersToggle = (state, action) => {
  return {
    ...state,
    activeFiltersToggle: action.payload,
  };
};

const setDSMEnabledFeatures = (state, action) => {
  return {
    ...state,
    dsmEnabledFeatures: action.payload,
  };
};
